import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import devIcon from '../../assets/images/devIcon.png';
import maintenanceIcon from '../../assets/images/maintenance.png';
import infraIcon from '../../assets/images/infraIcon.png';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}

const Testimonial = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'testimonial section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'testimonial-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Atuação',
    paragraph: 'Atuamos em várias frente proporcionando soluções tecnológicas'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-right" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <img src={devIcon} alt="" />
                <h3 style={{ textAlign: 'center' }}>Desenvolvimento de Sistemas</h3>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider" />
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <img src={maintenanceIcon} alt="Suporte e Manutenção" style={{ width: 280 }} />
                <h3 style={{ textAlign: 'center' }}>Suporte e Manutenção</h3>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider" />

              </div>
            </div>

            <div className="tiles-item reveal-from-left" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <img src={infraIcon} alt="Suporte e Manutenção" style={{ width: 280 }} />

                <h3 style={{ textAlign: 'center' }}>Infraestrutura de Redes</h3>
                <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

Testimonial.propTypes = propTypes;
Testimonial.defaultProps = defaultProps;

export default Testimonial;